<template>
    <div class="signUpFrom" id="signUpContent">
        <div class="logo"></div>
        <h2 class="sign-title" v-if="!isTransfer">{{$t('language.login.signUpTitle')}}</h2>
        <h2 class="sign-title" v-else>{{$t('language.shareTransfers.signupTitleByTransfer')}}</h2>
        <hr class="sign-top-line">
        <div class="font14" style="margin-bottom:17px;">{{$t('language.login.tips')}}
            <span class="alink" @click="toSignIn()">{{$t('language.login.logInButton')}}</span>
        </div>
        <div class="mc-row"  >
            <label for="" class="ic-label ic-email" :class="inputClass(selectInput.email)">
                <input type="text" name="email" class="width100" :placeholder="$t('language.popup.email')" autoComplete="off" id="signUpEmail" v-model="email"
                    :class="inputClass(selectInput.email)"
                    @focus="focusInput('email')" @blur="testEmail()">
            </label>
            <p class="err tips-info" :class="tipsClass(selectInput.email)">{{tipsMsg.email}}</p>
        </div>
        <div class="mc-row"  >
            <label for="" class="ic-label ic-password" :class="inputClass(selectInput.password)">
                <input type="password" name="password" class="width100" autocomplete="new-password" :placeholder="$t('language.signUp.pwdTip')" id="signUpPsd" v-model="password"
                    :class="inputClass(selectInput.password)" ref="passwordSignUp"
                    @focus="focusInput('password')" @blur="testPassword()">
                <div class="password-eye" :class="showPassword?'icon-eye':'icon-eye-hide'" @click="checkShowPassword()"></div>
            </label>
            <p class="err tips-info" :class="tipsClass(selectInput.password)">{{tipsMsg.password}}</p>
        </div>
        <div class="turnstile-container" ref="turnstileContainer"></div>
        <div class="mc-row" :style="isVCode?'':'display:none'" >
            <label for="" class="ic-label ic-verification f-dib width68" :class="inputClass(selectInput.code)">
                <input type="text" name="verificationCode" :placeholder="$t('language.login.verificationCode')" class="width100" id="signUpCode" v-model="code"
                    :class="inputClass(selectInput.code)"
                    @focus="focusInput('code')" @blur="testCode()">
            </label>
            <div class="f-dib"><img class="sign-verificationCode" @click.stop="refreshAndClearCode()" :src="ficationCode"></div>
            <p class="err tips-info" :class="tipsClass(selectInput.code)">{{tipsMsg.code}}</p>
        </div>
        <div class="mc-row btn" style="margin-bottom:20px;">
            <p class="err tips-info" :class="tipsClass(selectInput.btn)" style="position: absolute;top:-21px;">{{tipsMsg.btn}}</p>
            <button class="login-btn" @click="signUp()" :class="selectInput.btn=='signing'?'no-click':''">
                <span v-if="selectInput.btn=='signing'">{{$t('language.signUp.signingUp')}}</span>
                <span v-else>{{$t('language.login.createAccount')}}</span>
            </button>
        </div>
        <div class="login-thirdLogin">
            <p class="thirdLogin-tip"><span>{{$t('language.login.continueWith')}}</span></p>
            <div class="thirdLogin">
                <button class="thirdLogin-btn" @click="thirdLogin('facebook')">
                    <span class="sign-third-logo sign-facebook"></span>
                </button>
                <button class="thirdLogin-btn" @click="thirdLogin('apple')">
                    <span class="sign-third-logo sign-apple"></span>
                </button>
                <button class="thirdLogin-btn" @click="thirdLogin('google_drive')">
                    <span class="sign-third-logo sign-google"></span>
                </button>
            </div>
        </div>
        <div class="font13" style="text-align: center;">
            <p class="f-margintop1" v-html="$t('language.signUp.tips2')">
            </p>
        </div>
        <div class="email-push-btn">
            <div class="email-push-check" @click="clickEmailPush()">
                <div class="icon-check" :class="emailPush?'':'icon-check-none'"></div>
            </div>
            <p class="email-push-tip">
                {{$t('language.signUp.emailPushTip')}}
            </p>
        </div>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import "@/assets/css/common_util.css";
import "@/assets/css/login_popup.css";
import loginUtil from "@/js/workspace/login_popup.js";
import commonUtils from "@/js/workspace/common_util.js";

const TURNSTILE_SCRIPT_ID = 'cloudflare-turnstile-script';
const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let turnstileScriptPromise = null;

function loadTurnstileScript() {
    if (window.turnstile) {
        return Promise.resolve(window.turnstile);
    }
    if (turnstileScriptPromise) {
        return turnstileScriptPromise;
    }

    turnstileScriptPromise = new Promise((resolve, reject) => {
        let script = document.getElementById(TURNSTILE_SCRIPT_ID);
        const onLoad = () => {
            if (!window.turnstile) {
                turnstileScriptPromise = null;
                reject(new Error('Turnstile API is unavailable'));
                return;
            }
            resolve(window.turnstile);
        };
        const onError = () => {
            turnstileScriptPromise = null;
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
            reject(new Error('Failed to load Turnstile API'));
        };

        if (script) {
            script.addEventListener('load', onLoad, { once: true });
            script.addEventListener('error', onError, { once: true });
            return;
        }

        script = document.createElement('script');
        script.id = TURNSTILE_SCRIPT_ID;
        script.src = TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.addEventListener('load', onLoad, { once: true });
        script.addEventListener('error', onError, { once: true });
        document.head.appendChild(script);
    });
    return turnstileScriptPromise;
}

export default {
    props: ['isTransfer'],//判断是否是分享传输页面
    components: {
    },
    data() {
        return {
            selectInput: {
                name: "normal",
                email: "normal",
                password: "normal",
                rePassword: "normal",
                code: "normal",
                btn: "normal"
            },
            name: "",
            email: "",
            password: "",
            rePassword: "",
            code: "",
            tipsMsg: {
                name: "",
                email: "",
                password: "",
                rePassword: "",
                code: "",
                btn: "",
            },
            ficationCode: '',
            vkey: '',
            user: '',
            emailPush: true,//是否推送订阅邮件
            isVCode: false,//是否显示验证码
            showPassword: false,//是否显示密码
            turnstileToken: '',
            turnstileWidgetId: null,
            turnstileWaiting: false,
        };
    },
    created() {

    },
    watch: {
        isVCode(val){
            this.$parent.signUpCode = val;
        }
    },
    mounted() {
        this.initPage();
        this.$nextTick(() => this.renderTurnstile());
    },
    beforeDestroy() {
        this.removeTurnstile();
    },
    methods: {
        renderTurnstile(){
            loadTurnstileScript().then(turnstile => {
                if(!this.$refs.turnstileContainer || this.turnstileWidgetId !== null) return;
                this.turnstileWidgetId = turnstile.render(this.$refs.turnstileContainer, {
                    sitekey: commonstate.turnstileSiteKey,
                    action: 'signup',
                    size: 'flexible',
                    appearance: 'interaction-only',
                    theme: 'light',
                    callback: token => {
                        this.turnstileToken = token;
                    },
                    'expired-callback': () => {
                        this.resetTurnstile();
                    },
                    'timeout-callback': () => {
                        this.resetTurnstile();
                    },
                    'error-callback': () => {
                        this.turnstileToken = '';
                    }
                });
            }).catch(error => {
                this.turnstileToken = '';
                console.warn('Turnstile initialization failed:', error.message);
            });
        },
        resetTurnstile(){
            this.turnstileToken = '';
            if(window.turnstile && this.turnstileWidgetId !== null){
                try {
                    window.turnstile.reset(this.turnstileWidgetId);
                } catch (error) {
                    console.warn('Turnstile reset failed:', error.message);
                }
            }
        },
        removeTurnstile(){
            this.turnstileToken = '';
            if(window.turnstile && this.turnstileWidgetId !== null){
                try {
                    window.turnstile.remove(this.turnstileWidgetId);
                } catch (error) {
                    console.warn('Turnstile removal failed:', error.message);
                }
            }
            this.turnstileWidgetId = null;
        },
        waitForTurnstileToken(timeout){
            const maxWait = timeout || 5000;
            const startedAt = Date.now();
            return new Promise(resolve => {
                const checkToken = () => {
                    if(this.turnstileToken || this._isBeingDestroyed || this._isDestroyed || Date.now() - startedAt >= maxWait){
                        resolve(this.turnstileToken);
                        return;
                    }
                    setTimeout(checkToken, 100);
                };
                checkToken();
            });
        },
        toSignIn(){
            this.$parent.state='signIn';
        },
        //初始化注册页面
        initPage(){
            this.selectInput = {
                name: "normal",
                email: "normal",
                password: "normal",
                rePassword: "normal",
                code: "normal",
                btn: "normal"
            },
            this.name = "",
            this.email = "",
            this.password = "",
            this.rePassword = "",
            this.code = "",
            this.tipsMsg = {
                name: "",
                email: "",
                password: "",
                rePassword: "",
                code: "",
                btn: "",
            },
            this.user="";
            this.vkey="";
            this.refreshAndClearCode();
        },
        backSignIn(){
            this.$parent.state = "signIn";
        },
        //tips获取样式（err或suc）
        tipsClass(type){
            return loginUtil.tipsClass(type);
        },
        //获取样式
        inputClass(type){
            return loginUtil.inputClass(type);
        },
        //获取焦点后清除提示
        focusInput(type){
            loginUtil.focusInput(this,type);
        },
        /* 检查格式 */
        testName(){
            loginUtil.testName(this);
        },
        testEmail(){
            loginUtil.testEmail(this);
        },
        testPassword(){
            loginUtil.testPassword(this);
        },
        testRePassword(){
            loginUtil.testRePassword(this);
        },
        testCode(){
            loginUtil.testCode(this);
        },
        thirdLogin(type){
            this.$parent.thirdLogin(type);
        },
        //获取验证码
        refreshAndClearCode() {
            let userEmail = this.email;
            this.vkey = this.Utils.generateVerifyKey();
            this.Utils.doVerifyCodeRequest("generate", {
                params: {
                    email: userEmail //这里是请求接口书需要传的数据
                },
                responseType: 'arraybuffer', //这里是声明期望返回的数据类型
                vkey: this.vkey
            }).then(response => {
                return 'data:image/png;base64,' + btoa(new Uint8Array(response).reduce((data, email) => data + String.fromCharCode(email), ''));
            }).then(data => { //这一次箭头函数是依赖于第一次.then函数处理的data值
                this.ficationCode = data

            });
        },
        //注册账号
        signUp(skipTurnstileWait){
            this.selectInput.btn = "normal";
            this.tipsMsg.btn = "";
            //校验参数
            // this.testName();
            this.testEmail();
            this.testPassword();
            // this.testRePassword();
            if(this.isVCode){
                this.testCode();
            }
            // if(this.selectInput.name=="error") return;
            if(this.selectInput.email=="error") return;
            if(this.selectInput.password=="error") return;
            // if(this.selectInput.rePassword=="error") return;
            if(this.selectInput.code=="error") return;
            if(this.selectInput.btn=="signing") return;
            if(!this.turnstileToken && !skipTurnstileWait){
                if(this.turnstileWaiting) return;
                this.turnstileWaiting = true;
                this.waitForTurnstileToken(3000).then(() => {
                    this.turnstileWaiting = false;
                    if(!this._isBeingDestroyed && !this._isDestroyed){
                        this.signUp(true);
                    }
                });
                return;
            }

            //准备注册
            // 获取用户的时区
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.selectInput.btn = "signing";
            var signUpData = {
                email: this.email,
                password: this.password,
                username: this.email.substring(0,this.email.lastIndexOf("@")),
                autoLogin: true,
                language: commonUtils.getLocaleTo(localStorage.getItem("locale")),
                isPush: this.emailPush?1:0,
                timezone: userTimeZone
            }
            if(this.turnstileToken){
                signUpData.turnstileToken = this.turnstileToken;
            }
            if(this.isVCode){
                signUpData.vcode = this.code;
                signUpData.vkey = this.vkey;
            }
            
            var xcd = $cookies.get('x-cd');
            if(xcd){
                signUpData.xcd = xcd;
            }
            this.Utils.doUserRequest("sign_up", signUpData).then(response => {
                if (response.message == "Success"&&response.status==200) {
                    //注册成功并自动登录
                    //this.selectInput.btn = "normal";
                    this.user = response.user;
                    if(this.user==null)return;
                    //获取当前时间
                    var nData = new Date().getTime();
                    //过期时间
                    var eData;
                    let Base64 = require('js-base64').Base64;
                    this.$cookies.set("email", Base64.encode(this.email), "1y");
                    this.$cookies.set("password", Base64.encode(this.password), "1y");
                    eData = nData + 24 * 60 * 60 * 7 *1000;//+7天
                    localStorage.setItem('expirationTime', eData);
                    commonUtils.setUserToLocal(this.user);
                    location.reload();

                    this.$store.commit('setleftbannerClick', -1);
                    this.$store.commit('setleftbannerMenuClick', 106);   
                }else if (response.status=="403"&&response.reason == "notSupportedRegion") {
                    let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
                    let link = commonstate.frontEndUrl+(language=="en"?"":"/"+language)+'/region-not-supported.html';
                    window.location.href = link;                 
                }else{
                    this.resetTurnstile();
                    if (response.reason == "verifyCodeInvalid") {
                        this.isVCode = true;
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = this.$t('language.login.exception.verifyCodeInvalid');
                    } else if (response.reason == "turnstileInvalid") {
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = response.message || response.msg;
                    } else if (response.reason == "emailExist") {
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = this.$t('language.login.exception.emailExist');
                    } else if(response.msg == "emailInvalid"){
                        this.selectInput.email = "error";
                        this.tipsMsg.email = this.$t('language.exception.emailInvalid');
                    } else{
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = response.msg;
                    }
                    if(this.isVCode){
                        this.refreshAndClearCode();
                    }
                    
                }
            }, err => {
                this.resetTurnstile();
                this.selectInput.btn = "error";
                this.tipsMsg.btn = err;
            })
        },
        clickEmailPush(){
            this.emailPush = !this.emailPush;
        },
        checkShowPassword(){
            this.showPassword = !this.showPassword;
            if(this.showPassword){
                this.$refs.passwordSignUp.type = "text";
            }else{
                this.$refs.passwordSignUp.type = "password";
            }
        },
    }
};
</script>

<style scoped>
.turnstile-container {
    display: flex;
    justify-content: center;
    width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/popup/share_page_popups/sign_up_popup.vue